// src/hooks/useLongPress.js
import { useCallback, useRef } from 'react';

const useLongPress = (
    onLongPress,
    { shouldPreventDefault = true, delay = 500 } = {}
) => {
    const timeout = useRef();
    const target = useRef();

    const start = useCallback(
        event => {
            if (shouldPreventDefault && event.target) {
                event.target.addEventListener("touchend", preventDefault, { passive: false });
                target.current = event.target;
            }
            timeout.current = setTimeout(() => {
                onLongPress(event);
            }, delay);
        },
        [onLongPress, delay, shouldPreventDefault]
    );

    const clear = useCallback(
        (event) => {
            timeout.current && clearTimeout(timeout.current);
            if (shouldPreventDefault && target.current) {
                target.current.removeEventListener("touchend", preventDefault);
            }
        },
        [shouldPreventDefault]
    );

    const preventDefault = (event) => {
        if (!event.cancelable) return;
        event.preventDefault();
    };

    return {
        onMouseDown: e => start(e),
        onTouchStart: e => start(e),
        onMouseUp: e => clear(e),
        onMouseLeave: e => clear(e),
        onTouchEnd: e => clear(e),
        onTouchMove: e => clear(e), // <-- THIS IS THE FIX
    };
};

export default useLongPress;